prodproApp.filter('nl2br', function(){
    return function(value){
        if(typeof value !== 'string') {
            return value;
        }

        return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
});